module.exports = __webpack_public_path__ + "img/html-background-texture.59c03fff.jpg";